import React from 'react';
import OrderDetail from '../Order/OrderDetail';

/**
 * /orderApproval/:id: the order page, where an admin approves or rejects a waiting order.
 * The component keeps its name, which the host maps to the Order Management permission.
 */
const OrderApprovalDetail = () => <OrderDetail />;

export default OrderApprovalDetail;
